import "./lib/env";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { registerSW } from "virtual:pwa-register";

registerSW({
  onNeedRefresh() {
    const updateSW = registerSW({ immediate: true });
    // Sonner toast is initialised inside App; dispatch a custom event instead
    window.dispatchEvent(new CustomEvent("pwa-update-available", { detail: { update: () => updateSW(true) } }));
  },
});

createRoot(document.getElementById("root")!).render(<App />);
